import DashboardIcon from "@mui/icons-material/Dashboard";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import BuildIcon from "@mui/icons-material/Build";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

// Create a custom hook for the navigation logic
export const useNavigationItems = () => {
  const { profile } = useSelector((state) => state.profile);
  const [isLoading, setIsLoading] = useState(true);
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    if (profile) {
      const permissions = profile?.permissions?.navigation || [];
      // Define all navigation items based on your permissions array
      const allNavItems = [
        {
          label: "Dashboard",
          icon: <DashboardIcon />,
          path: "/dashboard",
          permission: "dashboard",
        },
        {
          label: "Templates",
          icon: <DescriptionIcon />,
          path: "",
          submenu: true,
          submenuItems: [
            {
              label: "Fabrication",
              icon: <BuildIcon />,
              path: "/templates/fabrication",
              permission: "fabrication",
            },
            {
              label: "Painting Checklist",
              icon: <FormatPaintIcon />,
              path: "/templates/painting-checklist",
              permission: "painting_checklist",
            },
          ],
        },
        {
          label: "Create RFI",
          icon: <AddCircleOutlineIcon />,
          path: "/createRFI",
          permission: "create_rfi",
        },
      ];

      // Filter navigation items based on user permissions
      const filteredNavItems = allNavItems.filter((item) => {
        if (item.submenu) {
          // For submenus, check if user has permission for any submenu item
          const hasSubmenuPermission = item.submenuItems.some((subItem) =>
            permissions.includes(subItem.permission)
          );
          return hasSubmenuPermission;
        }
        // For regular items, check direct permission
        return permissions.includes(item.permission);
      });

      // Process submenu items - remove submenu items that user doesn't have permission for
      const processedNavItems = filteredNavItems.map((item) => {
        if (item.submenu && item.submenuItems) {
          const filteredSubmenuItems = item.submenuItems.filter((subItem) =>
            permissions.includes(subItem.permission)
          );
          return {
            ...item,
            submenuItems: filteredSubmenuItems,
          };
        }
        return item;
      });

      setNavItems(processedNavItems);
      setIsLoading(false);
    }
  }, [profile]);

  return { navItems, isLoading };
};

// Component version
const SidebarOptions = () => {
  const { navItems, isLoading } = useNavigationItems();
  if (isLoading || !navItems.length) return [];
  return navItems;
};

export default SidebarOptions;
